<script setup lang="ts">

import TimeOffList from "@/components/timeoff/TimeOffList.vue";
import TimeoffApprover from "@/components/timeoff/TimeoffApprover.vue";
import EditTimeoffTypeDialog from "@/components/timeoff/EditTimeoffTypeDialog.vue";
import Button from "primevue/button";
import {timeoffBackend, TimeoffDTO} from "@/backend/timeoff.backend.ts";
import {onMounted, ref} from "vue";
import {useAuthStore} from "@/stores";
import useAppToast from "@/composables/useAppToast";

const toaster = useAppToast();
const peopleTimeoffs = ref<TimeoffDTO[] | null>(null);
const editDialogVisible = ref(false);
const editingTimeoff = ref<TimeoffDTO | null>(null);

const loadPeople = async () => {
  peopleTimeoffs.value = await timeoffBackend.getPeopleTimeoffs();
};

const {isApprover} = useAuthStore();

function openEditDialog(timeoff: TimeoffDTO) {
  editingTimeoff.value = timeoff;
  editDialogVisible.value = true;
}

async function handleTypeUpdated() {
  await loadPeople();
}

onMounted(async () => {
  await loadPeople();
});

</script>

<template>
  <TimeOffList :timeoffList="peopleTimeoffs" @mounted="loadPeople">
    <template #timeoffActions="slotProps">
      <Button icon="pi pi-pencil" text severity="secondary"
              v-tooltip.top="'Edit type'"
              @click="openEditDialog(slotProps.data)"/>
      <TimeoffApprover :timeoff="slotProps.data" @refresh="loadPeople" v-if="isApprover"/>
    </template>
    <template #empty>
      <h3>Your people haven't requested any time off yet</h3>
    </template>
  </TimeOffList>
  <EditTimeoffTypeDialog
    v-model:visible="editDialogVisible"
    :timeoff="editingTimeoff"
    @updated="handleTypeUpdated"
  />
</template>
